import React, { Component } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { ConfirmModal } from '../components/ConfirmModal';
import { OHCIDDetailsPopUp } from '../components/OHCIDDetailsPopUp';
import { TableRoleDisplay } from '../components/TableRoleDisplay';
import { SupplierUserPopUp } from '../components/SupplierUserPopUp';
import RoleUtils from '../utils/roleUtils.js';
import { Loading } from '../components/Loading';
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/MaintainAccess.css';

export class PrimaryUserAdminTable extends Component {

    constructor(props) {
        super()
        this.handleClose = this.handleClose.bind(this);
  //      this.getAdminInfo = this.getAdminInfo.bind(this);
        this.updateAdminInfo = this.updateAdminInfo.bind(this);
        this.buildTable = this.buildTable.bind(this);
        this.updateAdminStatus = this.updateAdminStatus.bind(this);
        this.onAdminRoleChange = this.onAdminRoleChange.bind(this);
        this.state = {
            adminInfo: '',
            statusChange: false,
            adminStatus: false,
            isLoading: true,
            isLocked: false, //Used for Disabled as well
            lockedControlName: '' // Used for Disabled as well
        }
    }

    //Get admin info upon mount
    componentDidMount() {
        //Determine if current user can add user
        var needsData = (this.props.spuaInfo.contact) ? false : true;
        var isLocked = CommonUtils.determineContactDisabled(this.props.spuaInfo);
        if (!isLocked) {
            isLocked = CommonUtils.determineContactLocked(this.props.spuaInfo);
        }
        var lockedControlName = CommonUtils.determineInactiveContactRoleName(this.props.spuaInfo);
        console.log(`Current MOUNTED value of Needs Data: ${needsData} and Supplier Updated: ${this.props.isSupplierUpdated}`);
        this.setState({
            isLoading: (needsData && this.props.isSupplierUpdated),
            adminInfo: this.props.spuaInfo,
            adminStatus: this.props.spuaInfo.profileStatus,
            isLocked: isLocked,
            lockedControlName: lockedControlName
        });
    }

    //Get admin info update if props change i.e. company ID changes
    componentDidUpdate(prevProps) {
        if ((prevProps.currentCompanyId !== this.props.currentCompanyId) ||
            (JSON.stringify(prevProps.spuaInfo) !== JSON.stringify(this.props.spuaInfo))) {
            var isLocked = CommonUtils.determineContactDisabled(this.props.spuaInfo);
            if (!isLocked) {
                isLocked = CommonUtils.determineContactLocked(this.props.spuaInfo);
            }
            var lockedControlName = CommonUtils.determineInactiveContactRoleName(this.props.spuaInfo);
            console.log(`Current UPDATED value of Supplier: ${this.props.isSupplierUpdated}`);
            this.setState({
                isLoading: false, 
                adminInfo: this.props.spuaInfo,
                adminStatus: this.props.spuaInfo.profileStatus,
                isLocked: isLocked,
                lockedControlName: lockedControlName
            });            
        }
    }

    //Update admin status and return updated admin info JSON
    updateAdminInfo() {
   
        this.setState({ statusChange: false, isLoading: true });
        var userRoles = this.state.adminInfo.suppliers[0].contactRoles;
        var roles = userRoles.filter(r => r.enabled === true).map(a => a.roleId);
        const updatedUser = {
            supplierId: this.props.currentCompanyId,
            contactId: this.state.adminInfo.contactId,
            email:this.state.adminInfo.email,
            roleId: roles,
            enabled: false
        };
        ServiceCalls.updateSupplierUser(updatedUser).then(function (data) {
            if (data) {
                this.setState({ adminInfo: data, isLoading: false });
                this.props.onUserUpdated();
            }
            else {
                //update not successful. - need to handle
                this.setState({ isLoading: false, adminInfo: '' });
            }
        }.bind(this));
    }

    //Build status dropdown based on user role
    buildStatus() {
        const { currentUser, currentCompanyId } = this.props;
        const { adminInfo,adminStatus,isLocked } = this.state;
        var canViewAdmin = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms());
                //If locked, override canViewAdmin status
        canViewAdmin  =(isLocked)?false:canViewAdmin;
        return (CommonUtils.statusDisplayforToggle(adminStatus, canViewAdmin, adminInfo.ohcidRegistration, this.updateAdminStatus,isLocked)); 
    }

    //Capture status dropdown and indicate that status changed for confirm modal
    updateAdminStatus(e) {
        this.setState({ adminStatus: e.target.value, statusChange: true });
    }

    onAdminRoleChange() {
        this.setState({ isLoading: true });
        this.props.onUserUpdated();
        this.setState({ isLoading: false });
    }
    //Handle close method for confirmModal
    handleClose() {
        this.setState({ statusChange: false });
    }

    buildUserRecord() {
        const { adminInfo } = this.state;
        var newUser = {
            lastName: (adminInfo.lastName === '' || adminInfo.lastName === null ? "--" : adminInfo.lastName),
            firstName: (adminInfo.firstName === '' || adminInfo.firstName === null ? "--" : adminInfo.firstName),
            emailAddress: adminInfo.email,
            lastSignOnDate: CommonUtils.renderStatusDate(adminInfo.lastSignOnDate),
            status: CommonUtils.statusNameForContact(adminInfo), 
            statusDate: CommonUtils.renderStatusDate(adminInfo.statusDate),
            contactId: adminInfo.contactId,
            roles: adminInfo.suppliers[0].contactRoles, 
            registration: adminInfo.ohcidRegistration,
            statusNotes: '',
            active: adminInfo.profileStatus
        }
        return newUser;
    }

    buildTable() {
        const { currentUser, currentCompanyId } = this.props;
        const { adminInfo, isLocked, lockedControlName } = this.state;
        var spuaEmail = (adminInfo.contactId > 0) ? adminInfo.email : '';
        var isSPUA = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.supplierPortalUserAdminPerm());
        var isOAdminView = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms());
        var isSPUAView = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allAdminPerms());
        var isSPUAViewAndAdminInfoExists = (isSPUAView && adminInfo.contactId > 0)
        var currentContact =  isSPUAViewAndAdminInfoExists ? this.buildUserRecord() : {};
        var ohcidBtn = (isOAdminView) ? <OHCIDDetailsPopUp userEmail={spuaEmail} refreshTable={this.onAdminRoleChange} isSPUA={isSPUA} status={currentContact?.status} inviteType={currentContact?.registration?.inviteMessages} currentUser={currentUser} currentCompanyId={currentCompanyId} ></OHCIDDetailsPopUp> : <></>;
        var editBtn = isSPUAViewAndAdminInfoExists ? <SupplierUserPopUp btnClass="spuaEditBtn" key={currentCompanyId} isSPUAView={true} editMode="Edit" currentContact={currentContact} onUserAction={this.onAdminRoleChange} currentUser={currentUser} currentCompanyId={currentCompanyId} spuaEmail={spuaEmail} /> : <></>;
       
        return (adminInfo.contactId>0) 
            ? <>
                <Row className="access-headers">
                    <Col sm={1}>
                        <strong>Email Address</strong>
                    </Col>
                    <Col sm={3}>
                        <div className="access-breakWord">{spuaEmail}</div>
                    </Col>
                    <Col sm={1}>
                        <strong>First Name</strong>
                    </Col>
                     <Col sm={3}>
                        <div className="access-breakWord">{adminInfo.firstName == null ? <p>--</p> : adminInfo.firstName}</div>
                     </Col>
                    <Col sm={2}>
                       <strong>Status</strong>
                       </Col>
                    <Col sm={2}>
                            {this.buildStatus()}
                        </Col>
                   </Row>
                <Row className="access-headers">
                    <Col sm={1}>
                        <strong>Updated Date</strong>
                    </Col>
                    <Col sm={3}>
                        <div>{CommonUtils.renderStatusDate(adminInfo.statusDate)}</div>
                    </Col>
                    <Col sm={1}>
                        <strong>Last Name</strong></Col>
                    <Col sm={3}>
                        <div className="access-breakWord"> {adminInfo.lastName == null ? <p>--</p> : adminInfo.lastName}</div>
                    </Col>
                    {(isLocked)?<>
                    <Col sm={2}>
                        <strong>{lockedControlName}</strong>
                       </Col>
                    <Col sm={2}>
                          <Form.Group as="div" className="adminStatusCtrl" controlId="userLocked">
                            <Form.Switch
                                type="switch"
                                id="contactLocked"
                                className="userStatusOption"
                                disabled={(!(isOAdminView) || isLocked) }
                                checked={isLocked}
                            />
                        </Form.Group>
                        </Col>
                    </>
                        : <Col sm={4}>&nbsp;</Col>
                    }
                        </Row>
                <Row className="access-headers">
                    <Col sm={1}>
                        <strong>Security Role</strong></Col>
                    <Col sm={3}>
                        <TableRoleDisplay roles={adminInfo.suppliers[0].contactRoles} />
                    </Col>  
                    <Col sm={1}>
                        <strong>Last SignOn Date</strong>
                    </Col>
                    <Col sm={3}>
                        <div>{CommonUtils.renderStatusDate(adminInfo.lastSignOnDate)}</div>
                    </Col>
                    <Col sm={4}>                       
                        <div style={{ marginRight: "25px" }}>
                            {ohcidBtn}
                            {editBtn}                          
                        </div>
                     </Col>
                 </Row>
           
              
                </>
             : <Col><h4>No Primary Admin listed</h4></Col>;
    }

    render() {
        //Message to be passed in as prop to confirm modal
        var curStatus = (this.state.adminStatus === true) ? 'active' : 'inactive';
        var msg = `Are you sure you want to change the primary user admin's status to ${curStatus}?`;
        console.log(`IN SPUA RENDER  Loading Status: ${this.state.isLoading}`);
        var display = (this.state.isLoading)
            ? <div style={{ margin: "auto", width: "200px" }}>
                <Loading />
            </div>
            : this.buildTable();
        return (
            <>
                <Row>
                    <Col>
                        <h3 className="access-headers">Primary User Administrator</h3>
                    </Col>
                </Row>
                <ConfirmModal message={msg} handleAccept={this.updateAdminInfo} isOpen={this.state.statusChange} handleClose={this.handleClose} />
                <Container fluid className="searchInputAreas border-left-dark shadow borderCurve">
                    {display}
                </Container>
            </>
        )
    }
}